module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lee-picture-card"
  }, [_c('div', {
    staticClass: "card-actions justify-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "preview",
    style: ({
      backgroundImage: 'url(' + _vm.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "card-info"
  }, [_c('span', {
    staticClass: "large-text"
  }, [_vm._v(_vm._s(_vm.name) + " - " + _vm._s(_vm.id))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer justify-between"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(_vm._s(_vm.views))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(_vm._s(_vm.comments))])]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("more >")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5504d9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picture_card.vue
// module id = 608
// module chunks = 1